import { api } from '@/plugins/api';
import i18n from '@/plugins/i18n';

function getById({ modelName, id, _id, optionName = 'none', match }) {
	const providedId = id ? id : _id;
	return api.get(`/${i18n.locale}/crud/${modelName}/${optionName}/getById/${providedId}`, {
		params: { match: JSON.stringify(match) },
	});
}

function getArrayByFilter({ modelName, filter, optionName = 'none', match }) {
	return api.get(`/${i18n.locale}/crud/${modelName}/${optionName}/getArrayByFilter`, {
		params: { match: JSON.stringify(match), filter: JSON.stringify(filter) },
	});
}
function getObjectByFilter({ modelName, filter, optionName = 'none', match }) {
	return api.get(`/${i18n.locale}/crud/${modelName}/${optionName}/getObjectByFilter`, {
		params: { match: JSON.stringify(match), filter: JSON.stringify(filter) },
	});
}

function save({ modelName, items, optionName = 'none', match }) {
	return api.post(`/${i18n.locale}/crud/${modelName}/${optionName}/createOrUpdate`, items, {
		params: { match: JSON.stringify(match) },
	});
}

function upload({ modelName, file }) {
	if (file) {
		// eslint-disable-next-line no-undef
		const formData = new FormData();
		formData.append('file', file, file.name);

		return api.post(`/${i18n.locale}/crud/${modelName}/upload`, formData);
	} else {
		console.log('there are no files.');
	}
}

/**
 * Archives one or more items. This means store it in the "archive" collection and remove it from its old collection.
 * @param {*} model The Model you want to search in.
 * @param {*} ids Can be a single id, an array of ids, an item containing an id or an Array containing items with ids.
 * @returns
 */
function archive({ modelName, _ids, optionName = 'none', match }) {
	return api.post(`/${i18n.locale}/crud/${modelName}/${optionName}/archive`, _ids, {
		params: { match: JSON.stringify(match) },
	});
}

export default {
	api,
	crud: {
		getById,
		getArrayByFilter,
		getObjectByFilter,
		save,
		archive,
		upload,
	},
};
